import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import React, { useMemo } from "react";
import classes from "./SimpleTable.module.scss";
import { TableVirtuoso } from "react-virtuoso";

const VirtualTable = React.memo(({ data, title, firstColumn }) => {
  const rows = useMemo(() => data || [], [data]);

  const columns = (() => {
    if (!rows || rows.length === 0) return [];
    const keys = Object.keys(rows[0]);
    const orderedKeys = keys.includes(firstColumn)
      ? [firstColumn, ...keys.filter(k => k !== firstColumn)]
      : keys;
    return orderedKeys.map(key => ({ label: key, dataKey: key }));
  })();

  const VirtuosoTableComponents = {
    Scroller: React.forwardRef((props, ref) => (
      <TableContainer component={Paper} {...props} ref={ref} />
    )),
    Table: (props) => (
      <Table
        {...props}
        className={classes.virtusoTable}
      />
    ),
    TableHead: React.forwardRef((props, ref) => (
      <TableHead {...props} ref={ref} />
    )),
    TableRow,
    TableBody: React.forwardRef((props, ref) => (
      <TableBody {...props} ref={ref} />
    )),
  };

  function rowContent(_index, row) {
    return (
      <React.Fragment>
        {columns.map((column) => (
          <TableCell key={column.dataKey} align="left" className={classes.bodyCell}>
            {row[column.dataKey]}
          </TableCell>
        ))}
      </React.Fragment>
    );
  }

  function fixedHeaderContent() {
    return (
      <TableRow>
        {columns.map((column) => (
          <TableCell
            key={column.dataKey}
            variant="head"
            align="left"
            style={{ width: column.width }}
            className={classes.headerCell}
          >
            {column.label}
          </TableCell>
        ))}
      </TableRow>
    );
  }

  return (
    <div className={classes.tableWrapper}>
      {title && <h3 className={classes.title}>{title}</h3>}
        <TableVirtuoso
          data={rows}
          components={VirtuosoTableComponents}
          fixedHeaderContent={fixedHeaderContent}
          itemContent={rowContent}
          className={classes.virtuso}
        />
      </div>
  );
});

export default VirtualTable;
